import { useState } from "react";
import Table from "../../utils/utilities/Table/Table";

import InventoryRoundedIcon from '@mui/icons-material/InventoryRounded';

import { filters, headers} from "./config";

const InventoryItemList = () => {

  return (
    <Table tableId="inventory_items" title="Inventory Item" icon={InventoryRoundedIcon} headers={headers} filters={filters} defaultSort="-sku" idKey="inventory_item_id" NoTitle={true} />
  );
};

export default InventoryItemList;